import React, { useEffect, useState } from "react";
import { apiDelete, apiGet } from "helpers/api";
import { withCookies } from "react-cookie";
import { Button, Popconfirm, Table } from "antd";

function ManageTopicsForm({ urlStub, cookies }) {
    const [topics, setTopics] = useState([]);
    const [staleData, toggleStaleData] = useState(false);
    const [csrfToken] = useState(cookies.get("XSRF-TOKEN"));

    useEffect(() => apiGet("/api/topics", setTopics), [staleData]);

    const columns = [
        {
            title: "Name",
            dataIndex: "value",
            render: (value) => value.replace(/^\s+|\s+$/g, "_")
        },
        {
            title: "Topic Area (Parent)",
            dataIndex: "parent",
            render: (value) => value.replace(/^\s+|\s+$/g, "_")
        },
        {
            title: "Edit",
            dataIndex: "value",
            render: (value) => (
                <Button
                    type={"primary"}
                    className={"warning-btn"}
                    href={
                        urlStub +
                        "/edit-topic?name=" +
                        encodeURIComponent(value)
                    }
                >
                    Edit
                </Button>
            )
        },
        {
            title: "Delete",
            dataIndex: "value",
            render: (value) => (
                <Popconfirm
                    title={
                        <>
                            <b>Delete: </b>Are you sure?
                        </>
                    }
                    onConfirm={() => {
                        apiDelete(
                            "/api/topic?topic=" + encodeURIComponent(value),
                            csrfToken
                        );
                        toggleStaleData((p) => !p);
                    }}
                    onCancel={() => {}}
                    okText="Delete"
                    cancelText="Cancel"
                >
                    <Button type={"primary"} danger={true}>
                        Delete
                    </Button>
                </Popconfirm>
            )
        }
    ];

    return (
        <Table
            className={"adminTable"}
            dataSource={topics}
            columns={columns}
            pagination={false}
        />
    );
}

export default withCookies(ManageTopicsForm);
